const COMPANIES_INFO = [
  {
    name: "FINANEDI SL",
    direction: "Avda. Cardenal Benlloch 79 9 - 46021 Valencia",
    nif: "B72399710",
    bankAccount: "ES30 0182 6526 1402 0418 7845",
  },
  {
    name: "GEDESCO FACTORING S.L.U.",
    direction: "Avda. de Aragón 2 Bis Entlo.",
    nif: "B87319448",
    bankAccount: "ES42­0081­5084­08­0001501753",
  },
]

export const cesionText = () => {
  const company = COMPANIES_INFO[0]
  const { name, direction, nif, bankAccount } = company

  return `En virtud de contrato de cesión de créditos, este crédito ha sido cedido a ${name}, 
  ${direction}, y con N.I.F. nº ${nif}, 
  por lo que el único pago liberatorio será el que se realice a la citada entidad
  al vencimiento del crédito cedido mediante transferencia a la cuenta bancaria n.º ${bankAccount} de la titularidad de ${name},
  o mediante la emisión de los efectos cambiarios, o de los documentos de pago convenidos, en su caso,
  con la mercantil cedente, para pago del crédito cedido a su vencimiento, directamente a favor de ${name}, como cesionaria del crédito.`
}

export const INITIAL_QUERY_PARAMETERS = {
  maxResult: 20,
  skipCount: 0,
  sortingCriteria: { sort: "", property: "" },
  params: "",
}
